require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-jennersdorf-jennersdorf.json") })
        }
      }, "path---betreuungseinrichtungen-jennersdorf-jennersdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-jennersdorf-jennersdorf!./.cache/json/betreuungseinrichtungen-jennersdorf-jennersdorf.json
// module id = 913
// module chunks = 231608221292675